export const APP_NAME = 'permisos';
